import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = process.env.REACT_APP_BBYS_QUIZ_GOOGLE_ANALYTICS_GA4_KEY;

let initialized = false;

/**
 * Initialize GA4. Call this once, as early as possible (see src/index.js).
 */
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn(
      "[analytics] REACT_APP_BBYS_QUIZ_GOOGLE_ANALYTICS_GA4_KEY is not set — GA4 tracking is disabled.",
    );
    return;
  } 
  if (initialized) return;

  ReactGA.initialize(GA_MEASUREMENT_ID);
  initialized = true;
};

/**
 * Fired once the quiz session has successfully started (quiz data loaded).
 * Maps to the "Quiz Starts" metric.
 */
export const trackQuizStart = ({ sessionId } = {}) => {
  ReactGA.event("quiz_start", {
    quiz_name: "buy_before_you_sell_matchmaker",
    quiz_session_id: sessionId,
  });
};

/**
 * Fired every time a question is answered and submitted.
 * Maps to the "Question Responses" table (per question, per answer).
 */
// trackQuestionResponse — add sessionId to the params and the event:
export const trackQuestionResponse = ({
  sessionId,
  questionNumber,
  questionId,
  questionText,
  answerText,
  recommendedCompanyName,
}) => {
  ReactGA.event("question_response", {
    quiz_session_id: sessionId,
    question_number: questionNumber,
    question_id: questionId,
    question_text: questionText,
    answer_text: answerText,
    recommended_company_name: recommendedCompanyName,
  });
};

/**
 * Fired once the quiz result has been generated (last question submitted).
 * Maps to "Quiz Completions" and the "Quiz Results" (by company) table.
 */
export const trackQuizComplete = ({ sessionId, company }) => {
  ReactGA.event("quiz_complete", {
    quiz_session_id: sessionId,
    result_company: company || "unknown",
  });
};

/**
 * Fired when the user clicks the CTA button on the result screen.
 * Maps to "CTA Link Clicks" and the "CTA Link Clicks" (by company) table.
 */
export const trackCtaClick = ({ sessionId, company }) => {
  ReactGA.event("cta_click", {
    quiz_session_id: sessionId,
    result_company: company || "unknown",
  });
};
